exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Logic[data-v-4256ea0e]{outline:1px dashed #dcdfe6;padding:20px 10px 10px;margin:1px;min-height:40px;position:relative}.Logic-label[data-v-4256ea0e]{position:absolute;left:0;top:0;color:#fff;cursor:pointer;background:#bdc0c7;padding:0 6px;font-size:10px;line-height:16px;z-index:10}.Logic-label.Logic-label-active[data-v-4256ea0e]{background:#f56c6c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-4256ea0e","scoped":true,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LogicBox/LogicBox.vue
// module id = 127
// module chunks = 0